import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BannedWordListItem } from "../interfaces/banned-word-list-item.interface";
import { HttpContextTokens, HttpLoggingOptions } from "common";

const sharedUrl = '/senderidregistry/manage/banned-word';

@Injectable({
  providedIn: 'root',
})
export class BannedWordsApiService {
  http = inject(HttpClient);

  private httpContext: HttpContext = null;

  constructor() {
    this.initialiseHttpContext();
  }

  private initialiseHttpContext(): void {
    if (this.httpContext === null) {
      this.httpContext = new HttpContext();

      var httpLoggingOptions = new HttpLoggingOptions();

      //The order creation process uses post calls to build up the information on the API/DB
      //we don't want to see a "success" popup for each of those backgroud operations
      httpLoggingOptions.setDisplaySuccess('POST', false);
      httpLoggingOptions.setDisplaySuccess('PUT', false);
      httpLoggingOptions.setDisplaySuccess('DELETE', false);

      this.httpContext.set(HttpContextTokens.options, httpLoggingOptions);
    }
  }

  public getBannedWords$() {
    return this.http.get<BannedWordListItem[]>(sharedUrl);
  }

  public addBannedWord$(value: string) {
    return this.http.post(sharedUrl, { value }, { context: this.httpContext });
  }

  public updateBannedWord$(id: number, value: string) {
    return this.http.put(`${sharedUrl}/${id}`, { value }, { context: this.httpContext });
  }

  public deleteBannedWord$(id: number) {
    return this.http.delete(`${sharedUrl}/${id}`, { context: this.httpContext });
  }
}
